export default function TestimonialSection({ testimonial, accent }) {
  if (!testimonial) return null;
  return (
    <section className="border-t border-line/70 relative overflow-hidden" data-testid="testimonial-section">
      <div className="absolute inset-0 pointer-events-none" style={{ background: accent.radial }} />
      <div className="relative max-w-[820px] mx-auto px-5 lg:px-10 py-20 lg:py-24 text-center">
        <div className="w-14 h-14 rounded-full overflow-hidden border border-gold/40 mx-auto mb-8">
          <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover" />
        </div>
        <p className="font-display text-2xl sm:text-3xl tracking-tight leading-[1.3] max-w-[46ch] mx-auto">
          &ldquo;{testimonial.quote}&rdquo;
        </p>
        <p className="text-dim text-[13px] tracking-wide mt-6">
          — {testimonial.name}, {testimonial.city}
        </p>
      </div>
    </section>
  );
}
